export const translations = {
  en: {
    brand: "Bam Bam Bhole",
    tagline: "Har Har Mahadev. Play. Win. Repeat.",
    heroSub: "India's most thrilling gaming arena. Play electrifying games and climb the leaderboard.",
    playNow: "Play Now",
    login: "Login",
    signup: "Sign Up",
    logout: "Logout",
    email: "Email",
    password: "Password",
    name: "Name",
    continueGoogle: "Continue with Google",
    or: "OR",
    coins: "",
    wallet: "Wallet",
    lobby: "Lobby",
    leaderboard: "Leaderboard",
    claimBonus: "Claim Free Coins",
    dailyBonus: "Daily Bonus",
    streak: "Day Streak",
    nextIn: "Next in",
    spin: "Spin",
    spinWheel: "Lucky Spin Wheel",
    colorGame: "Color Prediction",
    diceGame: "Number & Dice",
    scratchGame: "Scratch Card",
    bet: "Bet",
    betAmount: "Bet Amount",
    play: "Play",
    rollDice: "Roll Dice",
    scratchNow: "Buy & Scratch",
    youWon: "You Won",
    youLost: "Better luck next time",
    green: "Green",
    red: "Red",
    violet: "Violet",
    number: "Number",
    over: "Over",
    under: "Under",
    target: "Target",
    multiplier: "Multiplier",
    winChance: "Win Chance",
    history: "History",
    recentWinners: "Recent Winners",
    topPlayers: "Top Players",
    transactions: "Transactions",
    resetCoins: "Reset Coins",
    balance: "Balance",
    totalWon: "Total Won",
    totalWagered: "Total Wagered",
    gamesPlayed: "Games Played",
    disclaimer: "",
    won: "won",
    loginToPlay: "Login to Play",
    welcome: "Welcome back",
    playingNow: "players playing right now",
    rulesTerms: "Rules & Terms",
    onlineNow: "players online right now",
    createAccount: "Create your account",
    noAccount: "No account?",
    haveAccount: "Already have an account?",
    rolling: "Rolling...",
    spinning: "Spinning...",
    result: "Result",
    playAgain: "Play Again",
    pickColor: "Pick a Color or Number",
    howToPlay: "How to play",
    autoSpin: "Auto Spin",
    stopAuto: "Stop Auto",
    allTime: "All Time",
    weekly: "This Week",
    net: "Net",
    rounds: "Rounds",
    sound: "Sound & Buzz",
    profile: "Profile",
    achievements: "Achievements",
    missions: "Daily Missions",
    referAndEarn: "Refer & Earn",
    yourCode: "Your Referral Code",
    inviteText: "Invite friends to play with you!",
    copy: "Copy",
    copied: "Copied!",
    share: "Share",
    referrals: "Referrals",
    earned: "Earned",
    claim: "Claim",
    claimed: "Claimed",
    completed: "Completed",
    locked: "Locked",
    unlocked: "Unlocked",
    jackpot: "JACKPOT!",
    jackpotMsg: "You hit the mega jackpot!",
    resetsDaily: "Resets daily at midnight",
    inviteBonus: "Friend's first deposit → You +₹50, Friend +₹50",
    payments: "Add / Withdraw",
    addMoney: "Add Money",
    withdraw: "Withdraw",
    coinStore: "Add Money",
    buyNow: "Buy Now",
    paymentHistory: "Payment History",
    deposit: "Deposit",
    withdrawal: "Withdrawal",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    paid: "Paid",
    method: "Method",
    upiId: "UPI ID",
    bankAccount: "Bank Account",
    amountCoins: "Amount to withdraw (₹)",
    minWithdrawNote: "Admin reviews every withdrawal request.",
    demoPayNote: "DEMO ONLY · No real money is charged or paid out",
    changePhoto: "Change Photo",
    uploading: "Uploading...",
    requestSent: "Withdrawal request sent!",
    adminPanel: "Admin Panel",
    bonusCoins: "bonus",
    content: "Content",
    announcement: "Announcement",
    textMessage: "Text Message",
    imageBanner: "Image / Banner",
    title: "Title",
    message: "Message",
    create: "Create",
    noAnnouncements: "No announcements yet",
    uploadImage: "Upload Image",
    aviator: "Aviator",
    aviatorDesc: "Cash out before the plane flies away!",
    teenPatti: "Teen Patti",
    teenPattiDesc: "Beat the dealer's 3-card hand",
    andarBahar: "Andar Bahar",
    andarBaharDesc: "Pick the side where the Joker lands",
    deal: "Deal",
    yourCards: "Your Cards",
    dealerCards: "Dealer",
    winPays: "Win pays",
    andar: "Andar",
    bahar: "Bahar",
    joker: "Joker",
    yourPick: "your pick",
    placeBet: "Place Bet",
    cashOut: "Cash Out",
    cashedOut: "Cashed out",
    flewAway: "Flew away at",
    placeBetToFly: "Place a bet to start the flight",
    aviatorTip: "Tap Cash Out before the plane flies away to keep your winnings.",
    support: "Support",
    supportDesc: "Chat with our team — we usually reply fast",
    supportEmpty: "Send us a message and the team will get back to you here.",
    supportTeam: "Support Team",
    typeMessage: "Type a message...",
    supportInbox: "Support Inbox",
    noChats: "No conversations yet",
    reply: "Reply",
    autoCashOut: "Auto Cash Out",
    at: "at",
    thisRound: "This Round",
    recentWins: "Recent Flights",
    flying: "flying",
    busted: "busted",
    players: "players",
    quickReplies: "Quick Replies",
    allGames: "All Games",
    shareWin: "Share Win",
    shareWinTitle: "Invite friends to play together!",
    copied: "Copied!",
    period: "Period",
    bettingOpen: "Place your bets",
    bettingClosed: "Betting Closed",
    waitingResult: "Waiting for result...",
    confirmBet: "Confirm Bet",
    myBets: "My Bets this round",
    timeLeft: "Time Left",
    resultLabel: "Result",
    autoBet: "Auto Bet",
    roundsWord: "rounds",
    gameStats: "Your Game Stats",
    bestWin: "Best Win",
    bestMulti: "Best Multi",
    roundsPlayed: "Rounds",
    sendImage: "Send image",
    forceNextResult: "Force Next Result",
    cleared: "Cleared",
    newRound: "New round — place your bets!",
    downloadImage: "Save Image",
    imageSaved: "Image saved!",
    liveBets: "Live Bets",
    topWinners: "Top Winners",
    freeSpin: "Free Daily Spin",
    nextFreeSpin: "Next free spin in",
    invitedFriends: "Invited Friends",
    dailyWinners: "Yesterday's Top Winners",
    depositHint: "Send a deposit request — admin will add the balance after approval.",
    depositRequested: "Deposit request sent — pending admin approval",
    notifications: "Notifications",
    noNotifications: "No notifications yet",
    dragonTiger: "Dragon Tiger",
    dragonTigerDesc: "Higher card wins — Dragon or Tiger?",
    dragon: "Dragon",
    tiger: "Tiger",
    tie: "Tie",
    payUpi: "Pay to this UPI ID",
    scanToPay: "Scan & Pay",
    copyUpi: "Copy UPI ID",
    enterUtr: "UTR / Reference number",
    utrHint: "After paying, enter the UTR/reference number from your payment app, then submit.",
    amountToAdd: "Amount to add (₹)",
    submitDeposit: "Submit Deposit Request",
    howToDeposit: "How to add money",
    depositStep1: "Pay the amount to the UPI ID / QR below",
    depositStep2: "Enter the amount and UTR/reference number",
    depositStep3: "Submit — admin adds your balance after verifying",
    saveDetails: "Save for next time",
    savedDetails: "Saved payout details",
    inviteFriends: "Invite Friends",
    downloadPoster: "Download Invite Poster",
    payInfo: "Payment Details",
    reports: "Reports",
    depositsLabel: "Deposits",
    withdrawalsLabel: "Withdrawals",
    houseProfitLabel: "House Profit",
    uploadProof: "Upload payment screenshot (optional)",
    adminLogin: "Admin Login",
    adminOnly: "This area is for administrators only",
    notAdmin: "This account does not have admin access",
    viewSite: "View Site",
    maintenanceMode: "Maintenance Mode",
    maintenanceTitle: "We'll be right back",
    maintenanceDefault: "The site is under maintenance. Please try again shortly.",
    maintenanceOn: "Site is OFFLINE for players",
    maintenanceOff: "Site is LIVE",
    turnOn: "Turn ON",
    turnOff: "Turn OFF",
    referEarnTerms: "You and your friend each get ₹50 when your friend makes their first deposit.",
    winRate: "Win %",
    maxBet: "Max Bet",
    dailyWithdrawLimit: "Daily Withdraw Limit",
    rename: "Rename",
    note: "Note",
    adminLoginLink: "Are you an admin? Login here",
    kyc: "KYC",
    kycVerify: "KYC Verification",
    kycRequired: "Complete KYC verification to withdraw",
    kycPending: "KYC under review — withdrawals open once approved",
    kycApproved: "KYC verified",
    kycRejected: "KYC rejected — please re-upload your documents",
    uploadDocs: "Upload your documents",
    submitKyc: "Submit for verification",
    docAadhaar: "Aadhaar Card",
    docPan: "PAN Card",
    docSelfie: "Selfie Photo",
    docBank: "Bank Proof",
    uploaded: "Uploaded",
    history: "History",
    myHistory: "My History",
    txHistory: "Transaction & Game History",
    promoCode: "Promo code",
    havePromo: "Have a promo code?",
    redeem: "Redeem",
    promoApplied: "Promo applied! Balance updated",
    paymentMethods: "Payment Methods (UPI/QR)",
    addMethod: "Add method",
    active: "Active",
    inactive: "Inactive",
    promos: "Promos",
    createPromo: "Create promo code",
    maxUses: "Max uses",
    allGames: "All",
    noActivity: "No activity yet",
    lowBalanceTitle: "Low balance",
    lowBalanceMsg: "Add money to keep playing",
    lowBalanceZero: "Your balance is ₹0 — add money to start playing",
  },
  hi: {
    brand: "Bam Bam Bhole",
    tagline: "भोले के नाम से खेलो. जीतो. दोहराओ.",
    heroSub: "भारत का सबसे रोमांचक गेमिंग अरीना। धमाकेदार गेम खेलें और लीडरबोर्ड पर चढ़ें।",
    playNow: "अभी खेलें",
    login: "लॉगिन",
    signup: "साइन अप",
    logout: "लॉगआउट",
    email: "ईमेल",
    password: "पासवर्ड",
    name: "नाम",
    continueGoogle: "Google से जारी रखें",
    or: "या",
    coins: "",
    wallet: "वॉलेट",
    lobby: "लॉबी",
    leaderboard: "लीडरबोर्ड",
    claimBonus: "फ्री कॉइन्स पाएं",
    dailyBonus: "डेली बोनस",
    streak: "दिन की स्ट्रीक",
    nextIn: "अगला",
    spin: "घुमाएं",
    spinWheel: "लकी स्पिन व्हील",
    colorGame: "कलर प्रेडिक्शन",
    diceGame: "नंबर और डाइस",
    scratchGame: "स्क्रैच कार्ड",
    bet: "दांव",
    betAmount: "दांव राशि",
    play: "खेलें",
    rollDice: "डाइस घुमाएं",
    scratchNow: "खरीदें और स्क्रैच करें",
    youWon: "आप जीते",
    youLost: "अगली बार बेहतर किस्मत",
    green: "हरा",
    red: "लाल",
    violet: "बैंगनी",
    number: "नंबर",
    over: "ज़्यादा",
    under: "कम",
    target: "लक्ष्य",
    multiplier: "गुणक",
    winChance: "जीत संभावना",
    history: "इतिहास",
    recentWinners: "हाल के विजेता",
    topPlayers: "टॉप खिलाड़ी",
    transactions: "लेन-देन",
    resetCoins: "कॉइन्स रीसेट करें",
    balance: "बैलेंस",
    totalWon: "कुल जीत",
    totalWagered: "कुल दांव",
    gamesPlayed: "खेले गए गेम",
    disclaimer: "",
    won: "जीते",
    loginToPlay: "खेलने के लिए लॉगिन करें",
    welcome: "वापसी पर स्वागत है",
    playingNow: "लोग अभी खेल रहे हैं",
    rulesTerms: "नियम और शर्तें",
    onlineNow: "लोग अभी ऑनलाइन हैं",
    createAccount: "अपना खाता बनाएं",
    noAccount: "खाता नहीं है?",
    haveAccount: "पहले से खाता है?",
    rolling: "घूम रहा है...",
    spinning: "घुमा रहे हैं...",
    result: "परिणाम",
    playAgain: "फिर से खेलें",
    pickColor: "रंग या नंबर चुनें",
    howToPlay: "कैसे खेलें",
    autoSpin: "ऑटो स्पिन",
    stopAuto: "ऑटो बंद करें",
    allTime: "ऑल टाइम",
    weekly: "इस हफ़्ते",
    net: "नेट",
    rounds: "राउंड",
    sound: "साउंड और वाइब्रेशन",
    profile: "प्रोफ़ाइल",
    achievements: "उपलब्धियां",
    missions: "डेली मिशन",
    referAndEarn: "रेफर करें और कमाएं",
    yourCode: "आपका रेफरल कोड",
    inviteText: "दोस्तों को खेलने के लिए बुलाएं!",
    copy: "कॉपी",
    copied: "कॉपी हुआ!",
    share: "शेयर",
    referrals: "रेफरल",
    earned: "कमाए",
    claim: "क्लेम करें",
    claimed: "क्लेम हुआ",
    completed: "पूरा हुआ",
    locked: "लॉक",
    unlocked: "अनलॉक",
    jackpot: "जैकपॉट!",
    jackpotMsg: "आपने मेगा जैकपॉट जीता!",
    resetsDaily: "रोज़ आधी रात को रीसेट होता है",
    inviteBonus: "दोस्त का पहला डिपॉज़िट → आपको +₹50, दोस्त को +₹50",
    payments: "ऐड / विड्रॉ",
    addMoney: "पैसे जोड़ें",
    withdraw: "विड्रॉ",
    coinStore: "पैसे जोड़ें",
    buyNow: "अभी खरीदें",
    paymentHistory: "पेमेंट हिस्ट्री",
    deposit: "डिपॉज़िट",
    withdrawal: "विड्रॉल",
    pending: "पेंडिंग",
    approved: "स्वीकृत",
    rejected: "अस्वीकृत",
    paid: "भुगतान हुआ",
    method: "तरीका",
    upiId: "UPI आईडी",
    bankAccount: "बैंक खाता",
    amountCoins: "निकालने की रकम (₹)",
    minWithdrawNote: "हर विड्रॉल रिक्वेस्ट admin चेक करता है।",
    demoPayNote: "सिर्फ़ डेमो · कोई असली पैसा नहीं लिया/दिया जाता",
    changePhoto: "फोटो बदलें",
    uploading: "अपलोड हो रहा है...",
    requestSent: "विड्रॉल रिक्वेस्ट भेज दी गई!",
    adminPanel: "एडमिन पैनल",
    bonusCoins: "बोनस",
    content: "कंटेंट",
    announcement: "घोषणा",
    textMessage: "टेक्स्ट मैसेज",
    imageBanner: "इमेज / बैनर",
    title: "शीर्षक",
    message: "संदेश",
    create: "बनाएं",
    noAnnouncements: "अभी कोई घोषणा नहीं",
    uploadImage: "इमेज अपलोड करें",
    aviator: "एविएटर",
    aviatorDesc: "प्लेन उड़ने से पहले कैश आउट करें!",
    teenPatti: "तीन पत्ती",
    teenPattiDesc: "डीलर के 3 पत्तों को हराएं",
    andarBahar: "अंदर बाहर",
    andarBaharDesc: "चुनें जोकर किस तरफ गिरेगा",
    deal: "बाँटें",
    yourCards: "आपके पत्ते",
    dealerCards: "डीलर",
    winPays: "जीत पर मिलेगा",
    andar: "अंदर",
    bahar: "बाहर",
    joker: "जोकर",
    yourPick: "आपकी पसंद",
    placeBet: "दांव लगाएं",
    cashOut: "कैश आउट",
    cashedOut: "कैश आउट किया",
    flewAway: "उड़ गया",
    placeBetToFly: "उड़ान शुरू करने के लिए दांव लगाएं",
    aviatorTip: "प्लेन उड़ने से पहले कैश आउट दबाएं और अपनी जीत सुरक्षित रखें।",
    support: "सपोर्ट",
    supportDesc: "हमारी टीम से चैट करें — हम जल्दी जवाब देते हैं",
    supportEmpty: "हमें मैसेज भेजें, टीम यहीं जवाब देगी।",
    supportTeam: "सपोर्ट टीम",
    typeMessage: "मैसेज लिखें...",
    supportInbox: "सपोर्ट इनबॉक्स",
    noChats: "अभी कोई बातचीत नहीं",
    reply: "जवाब दें",
    autoCashOut: "ऑटो कैश आउट",
    at: "पर",
    thisRound: "इस राउंड में",
    recentWins: "हाल की उड़ानें",
    flying: "उड़ रहा",
    busted: "उड़ गया",
    players: "खिलाड़ी",
    quickReplies: "तुरंत जवाब",
    allGames: "सभी गेम",
    shareWin: "जीत शेयर करें",
    shareWinTitle: "दोस्तों को साथ खेलने के लिए बुलाओ!",
    copied: "कॉपी हो गया!",
    period: "पीरियड",
    bettingOpen: "दांव लगाएं",
    bettingClosed: "बेटिंग बंद",
    waitingResult: "रिज़ल्ट का इंतज़ार...",
    confirmBet: "बेट कन्फर्म करें",
    myBets: "इस राउंड के मेरे दांव",
    timeLeft: "बचा समय",
    resultLabel: "रिज़ल्ट",
    autoBet: "ऑटो बेट",
    roundsWord: "राउंड",
    gameStats: "आपके गेम आँकड़े",
    bestWin: "सबसे बड़ी जीत",
    bestMulti: "बेस्ट मल्टी",
    roundsPlayed: "राउंड",
    sendImage: "इमेज भेजें",
    forceNextResult: "अगला रिज़ल्ट फिक्स करें",
    cleared: "हटा दिया",
    newRound: "नया राउंड — दांव लगाएं!",
    downloadImage: "इमेज सेव करें",
    imageSaved: "इमेज सेव हो गई!",
    liveBets: "लाइव दांव",
    topWinners: "बड़े विजेता",
    freeSpin: "फ्री डेली स्पिन",
    nextFreeSpin: "अगला फ्री स्पिन",
    invitedFriends: "बुलाए गए दोस्त",
    dailyWinners: "कल के टॉप विजेता",
    depositHint: "डिपॉज़िट रिक्वेस्ट भेजें — अप्रूवल के बाद एडमिन बैलेंस जोड़ देगा।",
    depositRequested: "डिपॉज़िट रिक्वेस्ट भेज दी गई — एडमिन अप्रूवल बाकी",
    notifications: "सूचनाएं",
    noNotifications: "अभी कोई सूचना नहीं",
    dragonTiger: "ड्रैगन टाइगर",
    dragonTigerDesc: "बड़ा पत्ता जीतता है — ड्रैगन या टाइगर?",
    dragon: "ड्रैगन",
    tiger: "टाइगर",
    tie: "टाई",
    payUpi: "इस UPI आईडी पर भुगतान करें",
    scanToPay: "स्कैन करके भुगतान करें",
    copyUpi: "UPI आईडी कॉपी करें",
    enterUtr: "UTR / रेफरेंस नंबर",
    utrHint: "भुगतान के बाद अपने पेमेंट ऐप से UTR/रेफरेंस नंबर डालें, फिर सबमिट करें।",
    amountToAdd: "जोड़ने की रकम (₹)",
    submitDeposit: "डिपॉज़िट रिक्वेस्ट भेजें",
    howToDeposit: "पैसे कैसे जोड़ें",
    depositStep1: "नीचे दिए UPI आईडी / QR पर रकम भेजें",
    depositStep2: "रकम और UTR/रेफरेंस नंबर डालें",
    depositStep3: "सबमिट करें — वेरिफाई के बाद एडमिन बैलेंस जोड़ देगा",
    saveDetails: "अगली बार के लिए सेव करें",
    savedDetails: "पेआउट जानकारी सेव हुई",
    inviteFriends: "दोस्तों को बुलाएं",
    downloadPoster: "इनवाइट पोस्टर डाउनलोड करें",
    payInfo: "पेमेंट जानकारी",
    reports: "रिपोर्ट",
    depositsLabel: "डिपॉज़िट",
    withdrawalsLabel: "विड्रॉल",
    houseProfitLabel: "हाउस प्रॉफिट",
    uploadProof: "पेमेंट स्क्रीनशॉट अपलोड करें (वैकल्पिक)",
    adminLogin: "एडमिन लॉगिन",
    adminOnly: "यह हिस्सा सिर्फ एडमिन के लिए है",
    notAdmin: "इस अकाउंट के पास एडमिन एक्सेस नहीं है",
    viewSite: "साइट देखें",
    maintenanceMode: "मेंटेनेंस मोड",
    maintenanceTitle: "हम जल्द वापस आ रहे हैं",
    maintenanceDefault: "साइट अभी मेंटेनेंस में है। कृपया थोड़ी देर बाद प्रयास करें।",
    maintenanceOn: "साइट खिलाड़ियों के लिए बंद है",
    maintenanceOff: "साइट चालू है",
    turnOn: "चालू करें",
    turnOff: "बंद करें",
    referEarnTerms: "आपके दोस्त के पहले डिपॉज़िट पर आपको और आपके दोस्त दोनों को ₹50 मिलेंगे।",
    winRate: "जीत %",
    maxBet: "अधिकतम बेट",
    dailyWithdrawLimit: "रोज़ाना विड्रॉ लिमिट",
    rename: "नाम बदलें",
    note: "नोट",
    adminLoginLink: "क्या आप एडमिन हैं? यहाँ लॉगिन करें",
    kyc: "KYC",
    kycVerify: "KYC वेरिफिकेशन",
    kycRequired: "विड्रॉल के लिए KYC वेरिफिकेशन पूरा करें",
    kycPending: "KYC समीक्षा में है — अप्रूव होते ही विड्रॉल खुल जाएगा",
    kycApproved: "KYC वेरिफाइड",
    kycRejected: "KYC अस्वीकृत — कृपया दस्तावेज़ दोबारा अपलोड करें",
    uploadDocs: "अपने दस्तावेज़ अपलोड करें",
    submitKyc: "वेरिफिकेशन के लिए भेजें",
    docAadhaar: "आधार कार्ड",
    docPan: "पैन कार्ड",
    docSelfie: "सेल्फी फोटो",
    docBank: "बैंक प्रूफ",
    uploaded: "अपलोड हुआ",
    history: "हिस्ट्री",
    myHistory: "मेरी हिस्ट्री",
    txHistory: "लेन-देन और गेम हिस्ट्री",
    promoCode: "प्रोमो कोड",
    havePromo: "प्रोमो कोड है?",
    redeem: "रिडीम करें",
    promoApplied: "प्रोमो लागू! बैलेंस अपडेट हुआ",
    paymentMethods: "पेमेंट मेथड (UPI/QR)",
    addMethod: "मेथड जोड़ें",
    active: "चालू",
    inactive: "बंद",
    promos: "प्रोमो",
    createPromo: "प्रोमो कोड बनाएं",
    maxUses: "अधिकतम उपयोग",
    allGames: "सभी",
    noActivity: "कोई गतिविधि नहीं",
    lowBalanceTitle: "बैलेंस कम है",
    lowBalanceMsg: "खेलते रहने के लिए पैसे जोड़ें",
    lowBalanceZero: "आपका बैलेंस ₹0 है — खेलने के लिए पैसे जोड़ें",
  },
};
